var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 37,
    viewBox: "0 0 30 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6328 24.1328C28.3672 27.8047 27.0078 30.6953 24.5547 32.8047C22.1172 34.9141 18.8984 35.9688 14.8984 35.9688C10.5234 35.9688 7.07812 34.5 4.5625 31.5625C2.0625 28.6094 0.8125 24.5625 0.8125 19.4219V17.3359C0.8125 14.0547 1.39062 11.1641 2.54688 8.66406C3.70312 6.16406 5.35156 4.25 7.49219 2.92188C9.64844 1.57813 12.1484 0.90625 14.9922 0.90625C18.9297 0.90625 22.1016 1.96094 24.5078 4.07031C26.9141 6.17969 28.3047 9.14062 28.6797 12.9531H21.6484C21.4766 10.75 20.8594 9.15625 19.7969 8.17188C18.75 7.17187 17.1484 6.67188 14.9922 6.67188C12.6484 6.67188 10.8906 7.51562 9.71875 9.20312C8.5625 10.875 7.96875 13.4766 7.9375 17.0078V19.5859C7.9375 23.2734 8.49219 25.9688 9.60156 27.6719C10.7266 29.375 12.4922 30.2266 14.8984 30.2266C17.0703 30.2266 18.6875 29.7344 19.75 28.75C20.8281 27.75 21.4453 26.2109 21.6016 24.1328H28.6328Z",
    fill: "url(#paint0_linear_6_13)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_13",
    x1: 14.7461,
    y1: 0.90625,
    x2: 14.7461,
    y2: 35.9688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3477DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A9AE3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 36,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/C.d3f91da7416908aa84450049e0064e67.svg";
export { ForwardRef as ReactComponent };